export default "__VITE_ASSET__DlECOo4F__"